import { queryClient } from "@impero-com/common/utils/query_client";
import { useMutation } from "@tanstack/react-query";

import { NewUserTag } from "api/generated/model";
import { postTags } from "api/generated/tags/tags";

import { TAGS_QUERY_KEY } from "./useTagsQuery";

interface CreateTagMutationVars {
    tag: NewUserTag;
}

export const useCreateTagMutation = () =>
    useMutation({
        mutationFn: (vars: CreateTagMutationVars) =>
            postTags(vars.tag).then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                    return response.data;
                } else {
                    return Promise.reject(
                        new Error(
                            `Failed to create a new tag. HTTP status: ${response.status}`
                        )
                    );
                }
            }),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY }),
    });
